export default "__VITE_ASSET__BrnhK0ZM__"